import {lazy} from 'react';

// Lazy load the Analytics component
const Analytics = lazy(() => import('../views/Analytics/Analytics'));

const analyticsRoutes = [
    {
        exact: true,
        path: '/data-analytics',
        component: Analytics
    }
];

export default analyticsRoutes;
